__turbopack_context__.v({
  "modalArrowButton": "ImageGalleryCarouselModal-module__PWddQW__modalArrowButton",
  "modalArrowNext": "ImageGalleryCarouselModal-module__PWddQW__modalArrowNext",
  "modalArrowPrev": "ImageGalleryCarouselModal-module__PWddQW__modalArrowPrev",
  "modalCarousel": "ImageGalleryCarouselModal-module__PWddQW__modalCarousel",
  "modalContent": "ImageGalleryCarouselModal-module__PWddQW__modalContent",
  "modalDot": "ImageGalleryCarouselModal-module__PWddQW__modalDot",
  "modalDotActive": "ImageGalleryCarouselModal-module__PWddQW__modalDotActive",
  "modalDots": "ImageGalleryCarouselModal-module__PWddQW__modalDots",
  "modalImageFrame": "ImageGalleryCarouselModal-module__PWddQW__modalImageFrame",
  "modalScrollTrack": "ImageGalleryCarouselModal-module__PWddQW__modalScrollTrack",
  "modalSlide": "ImageGalleryCarouselModal-module__PWddQW__modalSlide",
  "modalSlideImage": "ImageGalleryCarouselModal-module__PWddQW__modalSlideImage",
});
